import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserDealersModel } from 'projects/Administration/src/app/business-entities/dealer-details.model';
import { SelectListItemViewModel } from 'projects/Administration/src/app/business-entities/select-list-item-view-model';
import { DealerBusinessService } from 'projects/Administration/src/app/business-services/dealer.service';
import { MechanicTimeCodeBusinessService } from 'projects/Administration/src/app/business-services/mechanic-time-code.service';
import { CurrentLanguage } from '../../../../../../../../Autofacets-Core/src/app/common-services/current-language.service';


@Component({
  selector: 'app-add-mechanic-time-code',
  templateUrl: './add-mechanic-time-code.component.html'
})
export class AddMechanicTimeCodeComponent implements OnInit {
  addMechanicTimeCode = false;
  addMechanicTimeCodeForm: FormGroup;
  dealerList: Array<SelectListItemViewModel>;
  languageList: any[];
  selectedDealer:any[]=[];
  dropdownSettings = {};
  selectedDealerId: string;
  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    public dealerBusinessService: DealerBusinessService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private currentLanguageService: CurrentLanguage,
    private mechanicTimeCodeService: MechanicTimeCodeBusinessService,
    private activeModal : NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 6,
      allowSearchFilter: false,
      maxHeight: 500
    };
    this.languageList = this.currentLanguageService.LanguageList;
    this.addMechanicTimeCodeForm = this.formBuilder.group({
      dealerId: ['', [Validators.required]],
      service: new FormArray([]),
      IsShow: [true],
    });
    this.getUserDealers();
    this.getLanguage();
  }
  get t() { return this.cpf.service as FormArray; }
  async getUserDealers(){
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapdealer(response.userDealersModel);
      if(this.dealerList.length === 1){
        this.selectedDealer = this.dealerList;
      }
    })
  }

  mapdealer(array: UserDealersModel[]){
    let supperArray = [];
    if (array && array.length > 0) {

      array.forEach(element=>{ 
        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName

        supperArray.push(single);
      })
    }
    return supperArray;
  }
  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
        for (let i = this.t.length; i < number; i++) {
            this.t.push(this.formBuilder.group({
                languageId: ['',],
                name: ['', Validators.required],
                description: ['', Validators.required],
            }));
        }
    } else {
        for (let i = this.t.length; i >= number; i--) {
            this.t.removeAt(i);
        }
    }
}
  get cpf() {
    return this.addMechanicTimeCodeForm.controls;
  }
  OnClose(){
    this.activeModal.close({success:false})
  }
  onSubmit() {
    this.spinner.show();
    let dealerId='';
        this.selectedDealer.forEach(element => {
            dealerId +=element.value + ','
        });
        this.selectedDealerId=dealerId.replace(/,\s*$/, "")
    let viewModel = {
      CreatedBy: '',
      DealerId:  this.selectedDealerId,
      IsShow: this.addMechanicTimeCodeForm.value.IsShow,
      Lnlnvalue: this.addMechanicTimeCodeForm.value.service,
      Id: 0
    }
    this.mechanicTimeCodeService.addMechanicTimeCodeList(viewModel).then(res => {
      if (res.responseObject) {
        let successMsg = this.translate.instant("lblMechanictimeCodeAdded");
        this.toastr.success(successMsg);
        this.activeModal.close({ success: true
        });
      }
      else {
        let errorMsg = this.translate.instant("lblMechanictimeCodeAlreadyAdded");
        this.toastr.warning(errorMsg)
      }
    })
    this.spinner.hide();
  }
  onDropdownDealerSelected(dealerId: any): void {
    if (dealerId == null) {
      this.selectedDealer = [];
      this.selectedDealerId='';
    } else {
      if (dealerId.length == 0) {
        this.selectedDealer= [];
        this.selectedDealerId=''
      }
      else
      {
        let dealerIdValue='';
        dealerId.forEach(element => {
            dealerIdValue +=element.value + ','
        });
        this.selectedDealerId=dealerIdValue;
      }
    }
  }
  async setDealerDetails() {
    let selectedDealerId = this.addMechanicTimeCodeForm.value.dealerId;
    if (selectedDealerId && selectedDealerId !== '') {
         await this.onDropdownDealerSelected(selectedDealerId)
    }
}

}
